import { render } from "./imagenSegunda.vue?vue&type=template&id=5aeb77f8&scoped=true"
import script from "./imagenSegunda.vue?vue&type=script&lang=js"
export * from "./imagenSegunda.vue?vue&type=script&lang=js"

import "./imagenSegunda.vue?vue&type=style&index=0&id=5aeb77f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aeb77f8"]])

export default __exports__